// eslint-disable-next-line no-console
export const api_url = process.env.REACT_APP_API_URL || "https://api.coc.nwappworks.com";
